var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"applicant-edit-tab-internal-history"}},[_c('ActionPage',{attrs:{"type":"APPLICANT","resource-id":_vm.$route.params.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }